import { Loading, useGetList } from "react-admin";
import { OrganizationList, OrganizationShow } from "../billing/organizations";

export const OrgOrganizationsList = (props) => {
  return <OrganizationList title="My Organizations" {...props} />;
};

export const OrgOrganizationsShow = () => {
  const { data, isLoading } = useGetList("org-organizations", {
    sort: { field: "id", order: "DESC" },
    filter: {},
  });

  if (isLoading) return <Loading />;

  const record = data?.[0];
  const id = parseInt(record?.id);

  return <OrganizationShow id={id} />;
};
